import React, { Fragment, useEffect, useState } from 'react';
import { post } from '../../Services/http';
import { translate } from '../../Services/translation';

const ArticleSearch = (props) => {
    const [searchTerm, setsearchTerm] = useState("");
    const [resultItems, setresultItems] = useState([]);
    const [searchClicked, setsearchClicked] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [resultSearchTerm, setresultSearchTerm] = useState("");

    const searchArticles = () => {     
        setresultSearchTerm("");
        post('/api/articlesearch', { competences: props.competences, queryText: searchTerm})
                .then((response) => response.json())
                .then((items) => {
                    setresultSearchTerm(searchTerm);
                    setresultItems(items);
        });
    }

    const searchArticlesOnClick = () => {                
        searchArticles();     
        setsearchClicked(true);   
    }

    const searchOnEnterClick = (e) => {
        if (e.key === "Enter") {
            searchArticlesOnClick();
        }
    }

    useEffect(() => {
        searchArticles();
    }, []);

    useEffect(() => {
        const mq = window.matchMedia("(max-width: 1024px)");

        const updateIsMobile = () => setIsMobile(mq.matches);

        updateIsMobile(); // sätt initialt värde
        mq.addEventListener("change", updateIsMobile);

        return () => mq.removeEventListener("change", updateIsMobile);
    }, []);

    const placeholderKey = isMobile
        ? "coptikk.eyehealthclinic.search.placeholder.mobile"
        : "coptikk.eyehealthclinic.search.placeholder";

    const buttonKey = isMobile
        ? "coptikk.eyehealthclinic.search.showresult.mobile"
        : "coptikk.eyehealthclinic.search.showresult";

    return(
        <div className='search-articles-page__content'>
            <div className='search-articles-page__search-wrapper'>
                <input type='text' value={searchTerm} onChange={(e) => setsearchTerm(e.target.value)} onKeyDown={(e) => searchOnEnterClick(e)} placeholder={translate(placeholderKey)}></input>
                <button className='button-navy' onClick={() => searchArticlesOnClick()}>{translate(buttonKey)}</button>
            </div>
            <div className='search-articles-page__search-results'>
                {searchClicked && resultSearchTerm && resultItems.length > 0 && <div dangerouslySetInnerHTML={{ __html:  
                    translate("coptikk.eyehealthclinic.search.resultcount").replace("{searchtext}", resultSearchTerm).replace("{count}", resultItems.length)}} ></div>}
                {resultItems && resultItems.map((item) => 
                    <a href={item.articleLink} className='search-articles-page__article-item'>
                        <div className='img-wrapper'>
                            <img src={item.imageUrl}></img>
                        </div>     
                        <div className='text-wrapper'>
                            <h3>{item.title}</h3>
                            <div dangerouslySetInnerHTML={{ __html: item.text }}></div>
                        </div>               
                    </a>
                )}
            </div>
        </div>
    )
}

export default ArticleSearch;